import { createContext, useContext, useState } from 'react';

import en from './locales/en';
import hu from './locales/hu';
import de from './locales/de';
import fr from './locales/fr';
import es from './locales/es';
import it from './locales/it';
import ja from './locales/ja';
import zh from './locales/zh';
import hi from './locales/hi';

const DICT = { en, hu, de, fr, es, it, ja, zh, hi };

export const LANGS = [
  { id: 'en', name: 'English',   flag: '🇬🇧' },
  { id: 'hu', name: 'Magyar',    flag: '🇭🇺' },
  { id: 'de', name: 'Deutsch',   flag: '🇩🇪' },
  { id: 'fr', name: 'Français',  flag: '🇫🇷' },
  { id: 'es', name: 'Español',   flag: '🇪🇸' },
  { id: 'it', name: 'Italiano',  flag: '🇮🇹' },
  { id: 'ja', name: '日本語',     flag: '🇯🇵' },
  { id: 'zh', name: '中文',       flag: '🇨🇳' },
  { id: 'hi', name: 'हिन्दी',     flag: '🇮🇳' },
];

const STORAGE_KEY = 'mz_lang';

function detectInitial() {
  if (typeof window === 'undefined') return 'en';
  try {
    const saved = window.localStorage?.getItem(STORAGE_KEY);
    if (saved && DICT[saved]) return saved;
  } catch (_) { /* private mode */ }
  const nav = (navigator.language || '').slice(0, 2);
  return DICT[nav] ? nav : 'en';
}

const LocaleCtx = createContext({ lang: 'en', setLang: () => {}, t: (k) => k });

export function LocaleProvider({ children }) {
  const [lang, setLangState] = useState(detectInitial);

  const setLang = (next) => {
    if (!DICT[next]) return;
    setLangState(next);
    try { window.localStorage?.setItem(STORAGE_KEY, next); } catch (_) {}
  };

  const dict = DICT[lang] || DICT.en;
  const t = (key) => dict[key] ?? DICT.en[key] ?? key;

  return (
    <LocaleCtx.Provider value={{ lang, setLang, t }}>
      {children}
    </LocaleCtx.Provider>
  );
}

export const useLocale = () => useContext(LocaleCtx);
export const useT = () => useContext(LocaleCtx).t;
